import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function AssistantFooter() {
  return (
    <Stack mt={3} spacing={0.5}>
      <Text weight="medium" size="xs" color="purple">
        <FormattedMessage id="businessProfile.aiAssistant.footer.brand" />
      </Text>

      <Text size="xs" color="secondary">
        <FormattedMessage id="businessProfile.aiAssistant.footer.description" />
      </Text>
    </Stack>
  );
}

AssistantFooter.propTypes = {
};

export default AssistantFooter;
